import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { Box, Card, Grid, LinearProgress, Typography, useTheme } from '@mui/material';

import { LayoutDashboard } from '../../../shared/layouts';
import { GenericService } from '../../../shared/services';
import { ISnackbarAlert, SnackbarAlert, CardList, TextFieldInput, ToolBar, ICardActions, ICardColumns, IChipFilter } from '../../../shared/components';
import { Feature } from '../../appSphere/feature/Feature';

interface IGenericCardListProps {
    entity: string;
    filter: any;
    cardActions: ICardActions[];
    cardColumns: ICardColumns[];
    loading1?: boolean;
    hasChildren: boolean | false;
    childrenTitle?: string;
    childrenComponent?: any;
    title?: string;
    setExpandedData: (value: any) => void;
}

export const GenericCardList: React.FC<IGenericCardListProps> = ({ entity, filter, cardActions, cardColumns, loading1, hasChildren, childrenTitle, childrenComponent, setExpandedData, title }) => {

    const [name, setName] = useState('');

    const [list, setList] = useState([]);

    const [actionExecuted, setActionExecuted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState<ISnackbarAlert>();
    const [isOpenSnackBar, setIsOpenSnackBar] = useState(false);

    const theme = useTheme();

    useEffect(() => {
        handleGetAllAsync();
    }, [loading1]);

    useEffect(() => {
        handleGetAllAsync();
    }, [name]);

    const handleGetAllAsync = useCallback(async () => {
        const localFilter: any = filter;

        localFilter.name = name;

        if (localFilter === undefined)
            return;

        GenericService.GetAllViewAsync1(entity, localFilter, setActionExecuted, setLoading, setList, showMessage, true);
    }, []);

    const handleClearFilterClick = () => {
        setName('');
    };

    function handleSearchClick() {
        handleGetAllAsync();
    }

    const chipFilters: IChipFilter[] = [
        { label: 'Total Records', value: list.length },
        { label: 'Name', value: name },
    ];

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarMessage(msg);
        setIsOpenSnackBar(true);
    }
    return (
        <React.Fragment>
            {isOpenSnackBar && (
                <SnackbarAlert
                    snackBarAlert={snackBarMessage}
                    setIsOpen={setIsOpenSnackBar}
                    isOpen={isOpenSnackBar}
                />
            )}
            <LayoutDashboard title=''>
                <Card sx={{ bgcolor: theme.palette.background.paper, p: 1, height: '56.5vh' }}>
                    <Typography>{title}</Typography>
                    <ToolBar
                        clickSearch={handleSearchClick}
                        clickClearFilter={handleClearFilterClick}
                        chipFilters={chipFilters}
                        actions={undefined}
                    >
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={12}>
                                <TextFieldInput
                                    id='name'
                                    label='Name'
                                    setValue={setName}
                                    value={name}
                                    placeholder={'Name'}
                                    maxLength={200}
                                />
                            </Grid>
                        </Grid>
                    </ToolBar>
                    {loading && (
                        <LinearProgress sx={{ borderRadius: 3, mt: - 0.7, mb: 0.2 }} />
                    )}
                    <Box sx={{ display: 'flex', maxHeight: '45.5vh', width: '100%', overflow: 'hidden', overflowY: 'auto' }}>
                        <CardList
                            columns={cardColumns}
                            rows={list}
                            actions={cardActions}
                            hasChildren={hasChildren}
                            setRowExpanded={setExpandedData}
                            cardSize={12}
                            childrenTitle={childrenTitle}
                            childrenComponent={(
                                childrenComponent
                            )}
                        />
                    </Box>
                </Card>
            </LayoutDashboard>
        </React.Fragment >
    );
};